import React from 'react';
import { cardSurfaceClass, cx } from '../theme';

/**
 * CooHero.
 *
 * The right-column "Coverage / Circles" boxes were promoted up to the
 * top SummaryBand (as pills). The data field `meta.summaryLines` is still
 * accepted in the shape so parsers/tests that produce it keep working — it
 * just isn't rendered here anymore.
 */
export default function CooHero({ meta }) {
  return (
    <section
      className={cx(
        cardSurfaceClass,
        'overflow-hidden border-white/10 bg-gradient-to-br from-[#041f3d] via-[#062B55] to-[#0a3768] text-white shadow-[0_10px_28px_rgba(6,43,85,0.18)]',
      )}
    >
      <div className="flex flex-col gap-3 px-6 py-6 lg:px-8">
        <div className="text-[10px] font-semibold uppercase tracking-[0.12em] text-white/[0.55]">
          AuditBuddy Executive View
        </div>
        <h1 data-coo="hero-title" className="text-[1.55rem] font-semibold leading-tight tracking-[-0.03em] sm:text-[1.75rem]">
          {meta.title}
        </h1>
        <div data-coo="hero-subtitle" className="text-sm leading-relaxed text-white/[0.58]">
          {meta.subtitle}
        </div>
        <div className="mt-2 flex flex-wrap gap-2">
          {meta.pills.map((pill) => (
            <span
              key={pill}
              data-coo="pill"
              className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.08] px-3.5 py-2 text-[11px] font-medium text-white"
            >
              {pill}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
